import { Audio } from 'react-loader-spinner'

export default function LoaderAudio() {

    return <Audio color="#00BFFF" height={80} width={80} />
}